import { Popover, Button, Alert } from "antd"
import { useState } from "react"
import { UploadButtonForm, StatefulUploadButtonForm } from ".."
import { PaperClipOutlined, UploadOutlined } from "@ant-design/icons"
import { toFileList } from "../../../helpers"
import PropTypes from "prop-types"
import { useEffect } from "react"

UploadTooltipHumanResources.propTypes = {
  body: PropTypes.string,
  small: PropTypes.bool,
  title: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  stateful: PropTypes.bool
}
export function UploadTooltipHumanResources({convocatoria = false ,IdentificadoBlock, onRemoveFileDocuments, accept, changeDocumetns, documents=[], body, small, title, readOnly, value, stateful = false, maxFile, isF50 }) {
  let otherTypeDocuments = [
    // RRHH
      "cv", 
      "job_profile", 
      "degree_certificate", 
      "title_master", 
      "additional_documents",
      "publication",
      "additional_cvs",   
    
    // Consultor
    "reference_quotes",
    "consultant_profile",
    "constitutive_act",
    "tax_situation",
    "compliance_opinion",
    "signed_quote",
    "business_cv",
    "id_document",
    "title_and_license",
    "public_call_documents",
    "received_cvs"]
  
  const [documentsFiles, setDocumentsFiles] = useState({
    cv: documents.filter(document => document.type === "cv") ?? [],
    job_profile: documents.filter(document => document.type === "job_profile") ?? [],
    degree_certificate: documents.filter(document => document.type === "degree_certificate") ?? [],
    title_master: documents.filter(document => document.type === "title_master") ?? [],
    additional_documents: documents.filter(document => document.type === "additional_documents") ?? [],
    publication: documents.filter(document => document.type === "publication") ?? [],
    additional_cvs:documents.filter(document => document.type === "additional_cvs") ?? [],
    old_documents: documents.filter(document => document.type === null || !otherTypeDocuments.includes(document.type)) ?? [],
    // Consultor
    reference_quotes:
    documents.filter(d => d.type === "reference_quotes") ?? [],
    consultant_profile:
    documents.filter(d => d.type === "consultant_profile") ?? [],
    constitutive_act:
      documents.filter(d => d.type === "constitutive_act") ?? [],
    tax_situation:
      documents.filter(d => d.type === "tax_situation") ?? [],
    compliance_opinion:
      documents.filter(d => d.type === "compliance_opinion") ?? [],
    signed_quote:
      documents.filter(d => d.type === "signed_quote") ?? [],
    business_cv:
      documents.filter(d => d.type === "business_cv") ?? [],
    id_document:
      documents.filter(d => d.type === "id_document") ?? [],
    title_and_license:
      documents.filter(d => d.type === "title_and_license") ?? [],
    public_call_documents:
      documents.filter(d => d.type === "public_call_documents") ?? [],
    received_cvs:
      documents.filter(d => d.type === "received_cvs") ?? [],
  })

  useEffect(() => {
    setDocumentsFiles({
      cv: documents.filter(document => document.type === "cv") ?? [],
      job_profile: documents.filter(document => document.type === "job_profile") ?? [],
      degree_certificate: documents.filter(document => document.type === "degree_certificate") ?? [],
      title_master: documents.filter(document => document.type === "title_master") ?? [],
      additional_documents: documents.filter(document => document.type === "additional_documents") ?? [],
      publication: documents.filter(document => document.type === "publication") ?? [],
      additional_cvs:documents.filter(document => document.type === "additional_cvs") ?? [],
      old_documents: documents.filter(document => document.type === null || !otherTypeDocuments.includes(document.type)) ?? [],
      // Consultor
      reference_quotes:
      documents.filter(d => d.type === "reference_quotes") ?? [],
      consultant_profile:
      documents.filter(d => d.type === "consultant_profile") ?? [],
      constitutive_act:
        documents.filter(d => d.type === "constitutive_act") ?? [],
      tax_situation:
        documents.filter(d => d.type === "tax_situation") ?? [],
      compliance_opinion:
        documents.filter(d => d.type === "compliance_opinion") ?? [],
      signed_quote:
        documents.filter(d => d.type === "signed_quote") ?? [],
      business_cv:
        documents.filter(d => d.type === "business_cv") ?? [],
      id_document:
        documents.filter(d => d.type === "id_document") ?? [],
      title_and_license:
        documents.filter(d => d.type === "title_and_license") ?? [],
      public_call_documents:
        documents.filter(d => d.type === "public_call_documents") ?? [],
      received_cvs:
        documents.filter(d => d.type === "received_cvs") ?? [],
    })
  }, [documents])

  const onDoneFile = async (files, type) => {
    const documents = files?.map(el => {
      return { name: el.name, url: el.url, type: type }
    })
    try {
      setDocumentsFiles({ ...documentsFiles, [type]: documents })
    }
    catch (e) {
      console.error(e)
    }
    changeDocumetns({ ...documentsFiles, [type]: documents })

  }

  const onRemoveFile = async ({ url }, type) => {

    setDocumentsFiles({ ...documentsFiles, [type]: documentsFiles[type].filter(document => document.url !== url) })
    onRemoveFileDocuments({ ...documentsFiles, [type]: documentsFiles[type].filter(document => document.url !== url) })
  }
  const isConsultantDocuments =
  documents?.some(doc =>
    [
      "reference_quotes",
      "consultant_profile",
      "constitutive_act",
      "tax_situation",
      "compliance_opinion",
      "signed_quote",
      "business_cv",
      "id_document",
      "title_and_license",
      "public_call_documents",
      "received_cvs"
    ].includes(doc.type)
  )
  

  const content = (
    <div style={{ width: "300px", height: "400px", overflowX: "hidden", overflowY: "scroll" }}>
    {!isConsultantDocuments && (
    <>
      <p>CV *</p>
      <UploadButtonForm
        fileList={toFileList(documentsFiles.cv)}
        disabled={readOnly}
        onRemoveFile={(url) => onRemoveFile(url, "cv")}
        onChange={(file) => onDoneFile(file, "cv")}
        OldDocuments={readOnly}
        accept={accept}>
        Adjuntar documento
      </UploadButtonForm>
      <br />
      <p>Perfil del puesto *</p>
      {!IdentificadoBlock ? 
     <UploadButtonForm
        fileList={toFileList(documentsFiles.job_profile)}
        disabled={readOnly }
        onRemoveFile={(url) => onRemoveFile(url, "job_profile")}
        onChange={(file) => onDoneFile(file, "job_profile")}
        accept={accept}
        OldDocuments={readOnly}
      >
        Adjuntar documento
      </UploadButtonForm> 
    :

    <UploadButtonForm
        fileList={toFileList(documentsFiles.job_profile)}
        disabled={false}
        onRemoveFile={(url) => onRemoveFile(url, "job_profile")}
        onChange={(file) => onDoneFile(file, "job_profile")}
        accept={accept}
      >
        Adjuntar documento
      </UploadButtonForm>
    
    }
      <br />
      <p>Título y Cédula Licenciatura</p>
      <UploadButtonForm
        fileList={toFileList(documentsFiles.degree_certificate)}
        disabled={readOnly}
        onRemoveFile={(url) => onRemoveFile(url, "degree_certificate")}
        onChange={(file) => onDoneFile(file, "degree_certificate")}
        accept={accept}
        OldDocuments={readOnly}
      >
        Adjuntar documento
      </UploadButtonForm>
      <br />
      <p>Título y Cédula Maestría</p>
      <UploadButtonForm
        fileList={toFileList(documentsFiles.title_master)}
        disabled={readOnly }
        onRemoveFile={(url) => onRemoveFile(url, "title_master")}
        onChange={(file) => onDoneFile(file, "title_master")}
        accept={accept}
        OldDocuments={readOnly}
      >
        Adjuntar documento
      </UploadButtonForm>
      <br />
    {(convocatoria || documentsFiles.publication?.length > 0) && (
    <>
    <p>Publicación de la vacante en capturas de pantalla *</p>
    <UploadButtonForm
      fileList={toFileList(documentsFiles.publication)}
      disabled={readOnly}
      onRemoveFile={(url) => onRemoveFile(url, "publication")}
      onChange={(file) => onDoneFile(file, "publication")}
      accept={accept}
      OldDocuments={readOnly}
      maxFile={maxFile}
    >
      Adjuntar documento
    </UploadButtonForm>
    <br />
  </>
  )}
  {(convocatoria || documentsFiles.additional_cvs?.length > 0) && (
    <>
      <p>CVs adicionales recibidos *</p>
      <UploadButtonForm
        fileList={toFileList(documentsFiles.additional_cvs)}
        disabled={readOnly}
        onRemoveFile={(url) => onRemoveFile(url, "additional_cvs")}
        onChange={(file) => onDoneFile(file, "additional_cvs")}
        accept={accept}
        OldDocuments={readOnly}
        maxFile={maxFile}
      >
        Adjuntar documento
      </UploadButtonForm>
      <br />
    </>
  )}
  </>
    )}

    {isConsultantDocuments && (
    <>
    {documentsFiles.reference_quotes?.length > 0 && (
      <>
        <p>Cotizaciones de referencia</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.reference_quotes)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "reference_quotes")
          }
          onChange={(file) =>
            onDoneFile(file, "reference_quotes")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.consultant_profile?.length > 0 && (
      <>
        <p>Perfil del consultor</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.consultant_profile)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "consultant_profile")
          }
          onChange={(file) =>
            onDoneFile(file, "consultant_profile")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.constitutive_act?.length > 0 && (
      <>
        <p>Acta constitutiva</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.constitutive_act)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "constitutive_act")
          }
          onChange={(file) =>
            onDoneFile(file, "constitutive_act")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.tax_situation?.length > 0 && (
      <>
        <p>Situación fiscal</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.tax_situation)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "tax_situation")
          }
          onChange={(file) =>
            onDoneFile(file, "tax_situation")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.compliance_opinion?.length > 0 && (
      <>
        <p>Opinión de cumplimiento</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.compliance_opinion)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "compliance_opinion")
          }
          onChange={(file) =>
            onDoneFile(file, "compliance_opinion")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.signed_quote?.length > 0 && (
      <>
        <p>Cotización firmada</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.signed_quote)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "signed_quote")
          }
          onChange={(file) =>
            onDoneFile(file, "signed_quote")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.business_cv?.length > 0 && (
      <>
        <p>CV empresarial</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.business_cv)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "business_cv")
          }
          onChange={(file) =>
            onDoneFile(file, "business_cv")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.id_document?.length > 0 && (
      <>
        <p>Identificación oficial</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.id_document)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "id_document")
          }
          onChange={(file) =>
            onDoneFile(file, "id_document")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.title_and_license?.length > 0 && (
      <>
        <p>Título y cédula</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.title_and_license)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "title_and_license")
          }
          onChange={(file) =>
            onDoneFile(file, "title_and_license")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.public_call_documents?.length > 0 && (
      <>
        <p>Documentos de convocatoria</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.public_call_documents)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "public_call_documents")
          }
          onChange={(file) =>
            onDoneFile(file, "public_call_documents")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}

    {documentsFiles.received_cvs?.length > 0 && (
      <>
        <p>CVs recibidos</p>

        <UploadButtonForm
          fileList={toFileList(documentsFiles.received_cvs)}
          disabled={readOnly}
          onRemoveFile={(url) =>
            onRemoveFile(url, "received_cvs")
          }
          onChange={(file) =>
            onDoneFile(file, "received_cvs")
          }
          accept={accept}
          OldDocuments={readOnly}
        >
          Adjuntar documento
        </UploadButtonForm>

        <br />
      </>
    )}
    </>
  )}
      <p>Documentos adicionales</p>
      <UploadButtonForm
        fileList={toFileList(documentsFiles.additional_documents)}
        disabled={readOnly }
        onRemoveFile={(url) => onRemoveFile(url, "additional_documents")}
        onChange={(file) => onDoneFile(file, "additional_documents")}
        accept={accept}
        maxFile={maxFile}
        OldDocuments={readOnly}
      >
        Adjuntar documento
      </UploadButtonForm>
      {
        documentsFiles.old_documents.length > 0 &&
        <>
          <br />
          <p>Documentos anteriores</p>
          <UploadButtonForm
            fileList={toFileList(documentsFiles.old_documents)}
            disabled={false}
            onRemoveFile={(url) => onRemoveFile(url, "old_documents")}
            accept={accept}
            maxFile={maxFile}
            OldDocuments={true}
          >
          </UploadButtonForm>
        </>
      }
    </div>
  )

  let tooltipButton = (
    <Button icon={<UploadOutlined />}>
      Adjuntar
    </Button>
  )

  if (small) {
    tooltipButton = (
      <Button
        shape="circle"
        icon={<PaperClipOutlined />} />
    )
  }

  if (isF50) {
    tooltipButton = (
      <Button
        shape="default"
        icon={<PaperClipOutlined />}>Documentos Anexos</Button>
    )
  }

  return (
    <Popover
      placement="right"
      content={content}
      title={""}
      zIndex={1031}
      trigger="click">
      {tooltipButton}
    </Popover>
  )
}